import React from 'react';
import { List, Button } from 'antd';
import { getValues  } from '../../virtuoso/helper';

/** Отображение краткой информации о распространении с сылкой на рспросранение */
export const AssetDistributionListItem = ({distribution, lang, onClick, canDeleted, onDelete}) => {
  const IRI = distribution.object.value;
  const header = (distribution.values)? getValues("http://purl.org/dc/terms/title", lang, distribution.values):IRI;
  const description = (distribution.values)? getValues("http://purl.org/dc/terms/description", lang, distribution.values):IRI;
  const actions= (canDeleted)?
    [
      <Button type="link" block onClick={(e)=>onDelete(e, IRI, header)}><span className="csi_cat_title" style={{}}>X</span></Button>  
    ]:[];
  return(
    <List.Item actions={actions} style={{borderRadius: 0}}>
      <List.Item.Meta 
        title={
          (onClick?
            <Button type="link" block onClick={(e)=>onClick(e, IRI)}>
              <span className="csi_cat_title" style={{color: "#0b5fff"}}>{header}</span>
            </Button>
          :
          <span className="csi_cat_title" style={{}}>{header}</span>
          )
        }
        description={description}
      />
    </List.Item>
  )
}